import { ConnectionValidationTypes, IADPState, IHeaderState, LastKnownGoodState, Views } from "../types/AppStateInterface";
import { IADPActions, IADPHeaderActions } from "./Actions";
import * as actionTypes from "../types/ActionTypes";
import { AppConfigExtended } from '../types/Config'
import { Content } from "../types/Content";
import { Battery } from "../types";
import { ConnectionStateType, LanguageSwitchType } from "@npd-ng/adp-benchmark";
import { SessionDetails } from "../types/BridgeTypes";
import { config } from "process";

export const initialHeaderState: IHeaderState = {
    networkConnectionState: ["WifiOff"],
    batteryState: "Danger",
    clockState: "",
    showBatteryWarning: false,
    selectedLocale: "en"
}

export const initialState: IADPState = {
    appState: {
        appLaunchId: undefined,
        appLaunchTime: new Date().toISOString(),
        appVersion: undefined,
        appCode: "",
        appBuildDate:undefined,
        releaseVersion: undefined,
        environment: undefined,
        configuration: undefined,
        currentView: "LoadingView",
        isPageReloaded: false,
        runtimePlatform: {
            platform: "Browser",
            version: "",
            userAgent: ""
        }
    },
    updateState: {
        isCheckForUpdateEnabled:false
    },
    deviceState: {
        batteryState: "Danger",
        battery: undefined,
        deviceId: undefined,
        deviceType: undefined,
        deviceModel: undefined,
        isDeviceHealthy: undefined
    },
    sessionState: {
        
        selectedLanguage: "english",
        selectedAssessmentMode: "notselected",
        networkConnectionState: "offline",
        serverConnectionState: undefined,
        schoolDetails: undefined,
        lastKnownGoodState: "Loading",
        providedSetupCode:undefined
    },
    deviceReadinessState: {
      validationState: undefined,
       validationError: undefined
    },
    networkReadinessState: {
        isRequired: undefined,
        executionState: undefined
    },
    staticContent: undefined
};
export function headerReducer(state: IHeaderState, action: IADPHeaderActions):IHeaderState{
    const logPrefix = "[ADPClient][HeaderAction]"
    console.log(logPrefix, action.type, action.payload)
    switch (action.type) {
        case actionTypes.SET_BATTERY:
        const batteryPyaload = action.payload as Battery
        return {
            ...state,
            batteryState: batteryPyaload.charging ?
                    "Charging" : batteryPyaload.level > 0.5 ?
                        "Full" : batteryPyaload.level < 0.3 ?
                            "Danger" : "Half",
            showBatteryWarning: batteryPyaload.charging ? false : batteryPyaload.level < 0.3 ? true : false
            }
    case actionTypes.SET_NETWORK:
        const networkPayload:ConnectionStateType = action.payload === "online" ? "Wifi" : action.payload === "router" ? "Router" : "WifiOff"
        
        return {
            ...state,
            networkConnectionState: [networkPayload]
        };
   case actionTypes.SET_LOCALE:
    return {
        ...state,
        selectedLocale: action.payload as unknown as LanguageSwitchType["selectedLocale"]
    };
    case actionTypes.SET_BATTERY_WARN:
    return {
        ...state,
        showBatteryWarning: false
    };
    default:
        return state;
    }
}
function getByValue(map: any, searchValue:Views) {
    for (let [key, value] of map.entries()) {
      if (value === searchValue)
        return key;
    }
  }
export const LastStateToViewMap = new Map<LastKnownGoodState,Views>([
    ["DeviceValidation", "DeviceValidationView"],
    ["Loading","LoadingView"],
    ["ModeSelection","ModeSelectionsView"],
    ["SetupCodeValidation","SetupCodeValidationView"],
    ["Update","UpdaterView"]
]);
export function reducer(state: IADPState, action: IADPActions): IADPState {
    const logPrefix = "[ADPClient][ADPAction]"
    console.log(logPrefix, action.type, action.payload);
    switch (action.type) {
        case actionTypes.SET_NETWORK:
            const networkPayload = action.payload
            return {
                ...state,
              sessionState:
                {
                    ...state.sessionState,
                    networkConnectionState: networkPayload
                }
              
            };
        case actionTypes.SHOW_ERROR_ACTION:
            return {
                ...state,
                 deviceReadinessState:{
                ...state.deviceReadinessState,
                validationError: action.payload
               },
               appState:{
                ...state.appState,
                currentView: "ErrorView"
               }
            }
        case actionTypes.SHOW_WARNING_ACTION:
          return {
                ...state,
                 deviceReadinessState:{
                ...state.deviceReadinessState,
                validationError: action.payload
               },
               appState:{
                ...state.appState,
                currentView: "WarningView"
               },
               sessionState:{
                ...state.sessionState,
                lastKnownGoodState: ["ErrorView","WarningView","WaitView"].includes(state.appState.currentView) ? state.sessionState.lastKnownGoodState :
                getByValue(LastStateToViewMap,state.appState.currentView)
               }
            }
        case actionTypes.SET_VALIDATION_ACTION:
            return {
                ...state,
               deviceReadinessState:{
                ...state.deviceReadinessState,
                validationState: action.payload
               }
            }   
        case actionTypes.UPDATE_SCHOOL:
        return {
            ...state,
            sessionState:{
                ...state.sessionState,
                providedSetupCode:action.payload?.setupCode,
                schoolDetails: action.payload
               },
        }

        case actionTypes.SET_ASSESSMENT_MODE:
            return {
                ...state,
                sessionState:{
                    ...state.sessionState,
                    selectedAssessmentMode: action.payload
                   },
            }
        case actionTypes.SET_VIEW:
            console.log('action.payload',action.payload)
           return {
                ...state,
                appState: {
                    ...state.appState,
                    currentView: action.payload
                },
                sessionState:{
                    ...state.sessionState,
                    lastKnownGoodState: ["ErrorView","WarningView","WaitView"].includes(state.appState.currentView) ? state.sessionState.lastKnownGoodState :
                    getByValue(LastStateToViewMap,state.appState.currentView)
                   }
            }
        case actionTypes.SET_CONFIG:
            const payload = action.payload as AppConfigExtended
            return {
                ...state,
                appState: {
                    ...state.appState,
                    environment: payload.environment,
                    configuration:{
                        ...state.appState.configuration,
                        ...payload
                    }
                },
                networkReadinessState: {
                    ...state.networkReadinessState,
                    isRequired: false //TODO - introduce in config 
                },

            };
            case actionTypes.SET_RELEASE_VERSION: 
                return {
                    ...state,
                    appState: {
                        ...state.appState,
                        releaseVersion: action.payload.release.version,
                        appCode: action.payload.app.code,
                        appVersion: action.payload.app.version,
                        appBuildDate:action.payload.app.buildDate,
                        configuration: {
                            ...state.appState.configuration as AppConfigExtended,
                            versionColors: action.payload.release.versionColors,
                            versionBorderColors: action.payload.release.versionBorderColors
                        }
                    },
                };
        case actionTypes.SET_CONTENT:
            const contentPyaload = action.payload as Content
            return {
                ...state,
                staticContent: contentPyaload,
            };
        case actionTypes.SET_SESSION_DETAILS:
            const sessionDetails= action.payload as SessionDetails
            return {
                ...state,
               appState:{
                ...state.appState,
                appLaunchId:sessionDetails.appLaunchId,
                releaseVersion: sessionDetails.releaseVersion || state.appState.releaseVersion,
                environment: sessionDetails.environment,
                runtimePlatform: sessionDetails.runtimePlatform,
                currentView:  sessionDetails.isCheckForUpdateEnabled && !sessionDetails.isPageReloaded 
                && sessionDetails.runtimePlatform.platform === "Electron" 
                && sessionDetails.networkConnectionState === "online" ? "UpdaterView": "ModeSelectionsView" ,
                isPageReloaded: sessionDetails.isPageReloaded
               }, 
               sessionState:{
                ...state.sessionState,
                networkConnectionState: sessionDetails.networkConnectionState ? sessionDetails.networkConnectionState : state.sessionState.networkConnectionState
               
               },
                deviceState:{
                    ...state.deviceState,
                    deviceId: sessionDetails.deviceId,
                    deviceModel: sessionDetails.deviceModel,
                    deviceType: sessionDetails.deviceType
                },
                updateState: {
                    ...state.updateState,
                    isCheckForUpdateEnabled: sessionDetails.isCheckForUpdateEnabled || false
                }
            }; 
         case actionTypes.SET_UPDATE_PROGRESS:
            return {
                ...state,
                updateState:{
                    ...state.updateState,
                    updateEvents: action.payload
                }
            }         
        default:
            return state;
    }
}




